import { AdminTabId } from "./adminTabs";
import { CategorySection } from "../CategorySection/CategorySection";
import { CheckSection } from "../CheckSection/CheckSection";
import { LimitsEnrichItemSection } from "../LimitsEnrichItemSection/LimitsEnrichItemSection";
import { PricelistSection } from "../PricelistSection/PricelistSection";
import { PolicyCheckSection } from "../PolicyCheckSection/PolicyCheckSection";
import { ItCheckSection } from "../ItCheckSection/ItCheckSection";
import { RequestsSection } from "../RequestsSection/RequestsSection";
import { TariffRequestsSection } from "../TariffRequestsSection/TariffRequestsSection";
import { PaymentSettingsSection } from "../PaymentSettingsSection/PaymentSettingsSection";
import { AdminUsersSection } from "../AdminUsersSection/AdminUsersSection";

interface AdminWorkspacePanelProps {
  activeTab: AdminTabId;
}

export const AdminWorkspacePanel = ({ activeTab }: AdminWorkspacePanelProps) => {
  switch (activeTab) {
    case "price-lists":
      return <PricelistSection />;
    case "limits-enrich":
      return <LimitsEnrichItemSection />;
    case "categories":
      return <CategorySection />;
    case "checks":
      return <CheckSection />;
    case "requests":
      return <RequestsSection embedded showHeader returnAdminTab="requests" />;
    case "policy-checks":
      return <PolicyCheckSection embedded returnAdminTab="policy-checks" />;
    case "it-checks":
      return <ItCheckSection embedded returnTab="it-checks" />;
    case "tariff-requests":
      return <TariffRequestsSection />;
    case "payments":
      return <PaymentSettingsSection />;
    case "users":
      return <AdminUsersSection />;
    default:
      return null;
  }
};
